export default __webpack_public_path__ + "static/media/3.ed4a4a0e.png";